import React from 'react';
import { SVGBasicType } from 'types/global';
import { Color } from 'utils/color';

export const CheckIcon = ({ width = 48, height = 48, color = Color.GRAY }: SVGBasicType) => {
  return (
    <svg width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M41.9906 13.9287C42.774 13.1501 42.7778 11.8838 41.9992 11.1003C41.2204 10.3169 39.9542 10.3131 39.1708 11.0917L17.9532 32.1808L8.82754 23.1148C8.04392 22.3364 6.7776 22.3406 5.99912 23.1242C5.22064 23.9078 5.2248 25.174 6.0084 25.9526L16.544 36.4192C17.3241 37.1942 18.5836 37.194 19.3635 36.4188L41.9906 13.9287Z"
        fill={color}
      />
    </svg>
  );
};
